import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'sort'
})
export class SortPipe implements PipeTransform {
    transform(arr: Array<any>, prop?: any, reverse: boolean = false): any {
        if (!arr) {
            return;
        }
        const m = reverse ? -1 : 1;
        return [...arr].sort((a: any, b: any): number => {
            let x = prop ? a[prop] : a;
            let y = prop ? b[prop] : b;

            if (typeof x === 'string' && (typeof y === 'string')){
                x = x.toLowerCase();
                y = y.toLowerCase();
            }

            return (x === y) ? 0 : (x < y) ? -1 * m : 1 * m;
        });
    }
}
